import React from 'react';
import { Marquee } from '../../ui/marquee';
import { ModelCard } from './ModelCard';
import { 
  Moonshot, OpenAI, Zhipu, Cohere, Claude, Gemini, 
  Minimax, Wenxin, Spark, DeepSeek, Qwen, Hunyuan, 
} from '@lobehub/icons';

// 自定义模型图标动效组件 - 使用Marquee滚动
export const ModelIconsAnimation = () => {
  const allModelIcons = [
    { Icon: OpenAI, name: 'OpenAI', color: 'from-green-400 to-green-600' },
    { Icon: Claude.Color, name: 'Claude', color: 'from-orange-400 to-red-500' },
    { Icon: Gemini.Color, name: 'Gemini', color: 'from-blue-400 to-purple-500' },
    { Icon: Zhipu.Color, name: 'ChatGLM', color: 'from-blue-500 to-blue-700' },
    { Icon: Moonshot, name: 'Moonshot', color: 'from-purple-400 to-purple-600' },
    { Icon: DeepSeek.Color, name: 'DeepSeek', color: 'from-gray-600 to-gray-800' },
    { Icon: Qwen.Color, name: 'Qwen', color: 'from-red-400 to-pink-500' },
    { Icon: Wenxin.Color, name: 'Wenxin', color: 'from-blue-400 to-cyan-500' },
    { Icon: Spark.Color, name: 'Spark', color: 'from-yellow-400 to-orange-500' },
    { Icon: Cohere.Color, name: 'Cohere', color: 'from-teal-400 to-green-500' },
    { Icon: Minimax.Color, name: 'Minimax', color: 'from-indigo-400 to-purple-500' },
    { Icon: Hunyuan.Color, name: 'Hunyuan', color: 'from-pink-400 to-rose-500' },
  ];

  const firstRow = allModelIcons.slice(0, 6);
  const secondRow = allModelIcons.slice(6, 12);

  return (
    <div className="absolute inset-0 overflow-hidden group/icons">
      <div className="absolute inset-2 flex flex-col items-center justify-center gap-1.5">
        {/* 第一行 - 正向滚动 */}
        <Marquee 
          pauseOnHover 
          className="[--duration:20s] [--gap:0.75rem] [mask-image:linear-gradient(to_right,transparent_0%,#000_15%,#000_85%,transparent_100%)]"
        >
          {firstRow.map((model, index) => (
            <ModelCard key={`first-${index}`} {...model} />
          ))}
        </Marquee>
        
        {/* 第二行 - 反向滚动 */}
        <Marquee 
          reverse 
          pauseOnHover 
          className="[--duration:25s] [--gap:0.75rem] [mask-image:linear-gradient(to_right,transparent_0%,#000_15%,#000_85%,transparent_100%)]"
        >
          {secondRow.map((model, index) => (
            <ModelCard key={`second-${index}`} {...model} />
          ))}
        </Marquee>
      </div>
    </div>
  );
}; 